export function splitText() {

    $(function() {


      // $('.splitText').each(function(){
      //   var text = $(this).text();
      //   var html = '';
      //   for(var i=0; i<text.length; i++) {
      //     html += '<span class="char">' + text.charAt(i) + '</span>';
      //   }
      //   $(this).html(html);
      // });

      $('.splitText').each(function(){
        var text = $(this).text();
        var html = '';
        for(var i=0; i<text.length; i++) {
          var c = text.charAt(i);
          // 半角スペース・全角スペースもspanに含める
          if (c === ' ') {
            html += '<span class="char space">&nbsp;</span>'; // 半角スペース
          } else if (c === '　') {
            html += '<span class="char zenkaku-space">　</span>'; // 全角スペース
          } else {
            html += '<span class="char">' + c + '</span>';
          }
        }
        $(this).html(html);
      });

    });



    //全角・半角スペースを含める

    
    
}
